import { AxiosInstance } from "axios";

export const getObjectThumbnail = (
  objectId: string,
  authenticatedRequest: AxiosInstance
) => authenticatedRequest.get<string>(`/api/v2/users/${objectId}/thumbnail`);
